import React from "react";
import { FiZap, FiFolder, FiFileText } from "react-icons/fi";
import { FaWallet } from "react-icons/fa";
import { FaStar } from "react-icons/fa";
import { FiCheckSquare } from "react-icons/fi";
import { FiEye, FiHeart, FiTrendingUp } from "react-icons/fi";
import {
  FiBell,
  FiGlobe,
  FiShield,
  FiClock,
   FiStar,
} from "react-icons/fi";

const SettlementSection = () => {
      const features = [
    {
      icon: "📊",
      title: "Instant mismatch alerts",
      description: "Get notified immediately when transactions don't match",
      circleIcon: "✔️",
    },
    {
      icon: "🔄",
      title: "Automated matching with zero effort",
      description: "Smart algorithms handle reconciliation automatically",
      circleIcon: "🔁",
    },
    {
      icon: "👁️",
      title: "100% payment visibility",
      description: "Complete transparency across all payment channels",
      circleIcon: "✅",
    },
  ];

const benefitsList = [
  {
    icon: <FiBell style={{ fontSize: "24px", color: "#059669" }} />,
    title: "Real-time alerts",
    description: "Get instant notifications for discrepancies",
  },
  {
    icon: <FiFolder style={{ fontSize: "24px", color: "#059669" }} />,
    title: "Auto-generated reports",
    description: "Professional reports generated automatically",
  },
  {
    icon: <FiGlobe style={{ fontSize: "24px", color: "#059669" }} />,
    title: "Multi-bank support",
    description: "Connect multiple banks and payment gateways",
  },
  {
    icon: <FiShield style={{ fontSize: "24px", color: "#059669" }} />,
    title: "Secure & compliant",
    description: "Bank-grade security and compliance",
  },
  {
    icon: <FiClock style={{ fontSize: "24px", color: "#059669" }} />,
    title: "Instant summaries",
    description: "Get quick overviews of your settlements",
  },
  {
    icon: <FiFileText style={{ fontSize: "24px", color: "#059669" }} />,
    title: "GST-ready statements",
    description: "Tax-compliant reports ready for filing",
  },
];

const businessPoints = [
  {
    icon: <FiEye style={{ fontSize: "24px", color: "#059669" }} />,
    title: "Spot Discrepancies Fast",
    description:
      "Advanced algorithms detect mismatches in seconds, not hours",
  },
  {
    icon: <FiHeart style={{ fontSize: "24px", color: "#059669" }} />,
    title: "Stress-Free Audits",
    description:
      "Complete audit trails and documentation at your fingertips",
  },
  {
    icon: <FiShield style={{ fontSize: "24px", color: "#059669" }} />,
    title: "Build Customer Trust",
    description:
      "Transparent processes and reliable settlements build confidence",
  },
];
const testimonials = [
  {
    quote: "TAPAY helped us reconcile 30,000+ transactions in a single day!",
    name: "Amandeep",
    title: "Finance Lead, UrbanBiz",
  },
  {
    quote:
      "Settlement accuracy improved by 99.8% after switching to TAPAY",
    name: "Priya Sharma",
    title: "CFO, TechStart",
  },
  {
    quote:
      "Our reconciliation time reduced from 6 hours to just 15 minutes",
    name: "Rajesh Kumar",
    title: "Accounts Manager, RetailMax",
  },
];
  return (
    <>
   <section
  style={{
    background: "#f0fdf4",
    padding: "40px 20px",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  }}
>
    <style>
        {`
          @keyframes slideInLeft {
            0% {
              transform: translateX(-50px);
              opacity: 0;
            }
            100% {
              transform: translateX(0);
              opacity: 1;
            }
          }

          @keyframes zoomIn {
            0% {
              transform: scale(0.8);
              opacity: 0;
            }
            100% {
              transform: scale(1);
              opacity: 1;
            }
          }

          .animated-left {
            animation: slideInLeft 1s ease-out forwards;
          }

          .zoom-in {
            animation: zoomIn 1s ease-out forwards;
          }
        `}
      </style>
  <div
    style={{
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      maxWidth: "1200px",
      margin: "0 auto",
      flexWrap: "wrap",
      gap: "40px",
    }}
  >
    {/* Left Content */}
    <div style={{ flex: "1 1 500px" }}className="animated-left">
      <h1
        style={{
          fontSize: "40px",
          fontWeight: "700",
          marginBottom: "20px",
          color: "#111827",
          lineHeight: "1.4",
        }}
      >
        Simplify Reconciliation & <br />
        <span style={{ color: "#10b981" }}>Settlements</span> with TAPAY
      </h1>
      <p
        style={{
          fontSize: "18px",
          color: "#6b7280",
          marginBottom: "30px",
        }}
      >
        Track, match, and receive payments — all in one smooth flow.
      </p>
      <button
        style={{
          background: "#10b981",
          color: "#ffffff",
          border: "none",
          borderRadius: "9999px",
          padding: "14px 28px",
          fontSize: "16px",
          fontWeight: "500",
          display: "inline-flex",
          alignItems: "center",
          gap: "10px",
          cursor: "pointer",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        🚀 Get Started Free →
      </button>
    </div>

    {/* Right Image */}
    <div style={{ flex: "1 1 400px", textAlign: "center" }}  className="zoom-in">
      <img
        src="/reconciliationimage.png"
        alt="Settlement Illustration"
        style={{ width: "100%", maxWidth: "500px", height: "auto" }}
      />
    </div>
  </div>
</section>

      <section
      style={{
        backgroundColor: "#f9fafb",
        padding: "60px 20px",
        textAlign: "center",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      {/* Heading */}
      <h2
        style={{
          fontSize: "35px",
          fontWeight: "700",
          color: "#111827",
          marginBottom: "10px",
        }}
      >
🔍 Reconciliation simplifies matching payments<br />across sales and bank records.
      </h2>
      <p
        style={{
          fontSize: "18px",
          color: "#6b7280",
          marginBottom: "40px",
          maxWidth: "700px",
          margin: "0 auto",
          lineHeight: "2",
        
        }}
      >
        Reconciliation helps you match and verify all your payments across
        sales, banks, and statements. With TAPAY, you get:
      </p>

      {/* Features Grid */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: "30px",
          marginTop:"30px"
        }}
      >
        {features.map((feature, index) => (
          <div
            key={index}
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "12px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
              padding: "30px 20px",
              width: "400px",
              textAlign: "center",
              transition: "transform 0.3s ease",
            }}
          >
            {/* Circle Icon */}
            <div
              style={{
                backgroundColor: "#d1fae5",
                width: "60px",
                height: "60px",
                borderRadius: "50%",
                margin: "0 auto 20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "28px",
              }}
            >
              {feature.circleIcon}
            </div>
            {/* Title */}
            <h3
              style={{
                fontSize: "18px",
                fontWeight: "600",
                color: "#111827",
                marginBottom: "10px",
              }}
            >
              {feature.icon} {feature.title}
            </h3>
            {/* Description */}
            <p
              style={{
                color: "#6b7280",
                fontSize: "17px",
                lineHeight: "1.5",
              }}
            >
              {feature.description}
            </p>
          </div>
        ))}
      </div>
    </section>

    <section
      style={{
        padding: "90px 80px",
        backgroundColor: "#f7fbfb",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          maxWidth: "1200px",
          width: "100%",
          gap: "40px",
          flexWrap: "wrap",
        }}
      >
        {/* Left Text Content */}
        <div style={{ flex: "1", minWidth: "300px" }}>
          <h2
            style={{
              fontSize: "35px",
              fontWeight: "700",
              display: "flex",
              alignItems: "center",
              gap: "12px",
              marginBottom: "20px",
              color: "#111827",
            }}
          >
            <FaWallet style={{ fontSize: "35px", color: "#844e4d" }} />
            <span style={{ color: "#111827" }}> Fast Reliable Settlement</span>
          </h2>
          <p
            style={{
              fontSize: "18px",
              color: "#6b7280",
              marginBottom: "32px",
              maxWidth: "500px",
              lineHeight: "1.6",
            }}
          >
            Settlement is the process where TAPAY ensures your funds reach your
            account safely and on time.
          </p>

          {/* Features */}
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {/* Feature 1 */}
            <li
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "16px",
                marginBottom: "24px",
              }}
            >
              <div
                style={{
                  backgroundColor: "#ddf8f3",
                  borderRadius: "9999px",
                  padding: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FiZap style={{ fontSize: "1.5rem", color: "#fbbf24" }} />
              </div>
              <div>
                <h4 style={{ margin: 0, fontWeight: "600", color: "#111827" ,fontSize:"20px",marginBottom:"10px"}}>
                  UPI & card settlements (T+1)
                </h4>
                <p style={{ margin: "4px 0 0", color: "#6b7280" }}>
                  Lightning-fast settlement cycles
                </p>
              </div>
            </li>

            {/* Feature 2 */}
            <li
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "16px",
                marginBottom: "24px",
              }}
            >
              <div
                style={{
                  backgroundColor: "#ddf8f3",
                  borderRadius: "9999px",
                  padding: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FiFolder style={{ fontSize: "1.5rem", color: "#facc15" }} />
              </div>
              <div>
                <h4 style={{ margin: 0, fontWeight: "600", color: "#111827"  ,fontSize:"20px",marginBottom:"10px"}}>
                  Transparent payment logs
                </h4>
                <p style={{ margin: "4px 0 0", color: "#6b7280" }}>
                  Detailed tracking of every transaction
                </p>
              </div>
            </li>

            {/* Feature 3 */}
            <li
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "16px",
                marginBottom: "24px",
              }}
            >
              <div
                style={{
                  backgroundColor: "#ddf8f3",
                  borderRadius: "9999px",
                  padding: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <FiFileText style={{ fontSize: "1.5rem", color: "#844e4d" }} />
              </div>
              <div>
                <h4 style={{ margin: 0, fontWeight: "600", color: "#111827" ,fontSize:"20px",marginBottom:"10px" }}>
                  Smart reports for accounting
                </h4>
                <p style={{ margin: "4px 0 0", color: "#6b7280" }}>
                  Automated reports ready for your accountant
                </p>
              </div>
            </li>
          </ul>
        </div>

        {/* Right Image */}
        <div
          style={{
            flex: "1",
            display: "flex",
            justifyContent: "center",
            minWidth: "300px",
          }}
        >
          <img
            src="/reconciliation.png"
            alt="Settlement Illustration"
            style={{
              maxWidth: "100%",
              height: "400px",
              borderRadius: "20px",
              boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.05)",
            }}
          />
        </div>
      </div>
    </section>
      <section
      style={{
        padding: "60px 20px",
        backgroundColor: "#f7fbfb",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* Heading */}
      <h2
        style={{
          fontSize: "35px",
          fontWeight: "700",
          color: "#111827",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "40px",
        }}
      >
        <FiStar style={{ color: "#f59e0b", fontSize: "1.5rem" }} />
        TAPAY Features
      </h2>

      {/* Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))",
          gap: "24px",
          maxWidth: "1300px",
          width: "100%",
        }}
      >
        {benefitsList.map((benefit, idx) => (
          <div
            key={idx}
            style={{
              backgroundColor: "white",
              borderRadius: "12px",
              padding: "40px 20px",
              textAlign: "center",
              boxShadow: "0px 10px 20px rgba(0,0,0,0.05)",
              transition: "transform 0.3s ease",
            }}
          >
            <div
              style={{
                backgroundColor: "#d1fae5",
                
                width: "58px",
                height: "58px",
                borderRadius: "50%",
                margin: "0 auto 20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {benefit.icon}
            </div>
            <h3
              style={{
                margin: "0 0 8px",
                fontSize: "1.2rem",
                fontWeight: "600",
                color: "#111827",
              }}
            >
              {benefit.title}
            </h3>
            <p style={{ color: "#6b7280", fontSize: "0.95rem" }}>
              {benefit.description}
            </p>
          </div>
        ))}
      </div>
    </section>
     <section
      style={{
        backgroundColor: "#f5fdfc",
        padding: "60px 20px",
        textAlign: "center",
      }}
    >
      {/* Heading */}
      <h2
        style={{
          fontSize: "35px",
          fontWeight: "700",
          color: "#111827",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
          marginBottom: "40px",
        }}
      >
        <FiTrendingUp style={{ fontSize: "1.75rem", color: "#6366f1" }} />
        Benefits for Your Business
      </h2>

      {/* Cards */}
      <div
        style={{
          display: "flex",
          gap: "24px",
          justifyContent: "center",
          flexWrap: "wrap",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        {businessPoints.map((item, index) => (
          <div
            key={index}
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "12px",
              padding: "30px 20px",
              textAlign: "center",
              maxWidth: "360px",
              flex: "1 1 280px",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.05)",
              transition: "transform 0.3s ease",
            }}
          >
            <div
              style={{
                backgroundColor: "#d1fae5",
                width: "56px",
                height: "56px",
                borderRadius: "50%",
                margin: "0 auto 16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {item.icon}
            </div>
            <h3
              style={{
                margin: "0 0 12px",
                fontSize: "1.125rem",
                fontWeight: "600",
                color: "#111827",
              }}
            >
              {item.title}
            </h3>
            <p style={{ color: "#6b7280", fontSize: "0.95rem" }}>
              {item.description}
            </p>
          </div>
        ))}
      </div>
    </section>
     <section
      style={{
        backgroundColor: "#f7fafd",
        padding: "60px 20px",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      {/* Heading */}
      <h2
        style={{
          fontSize: "35px",
          fontWeight: "700",
          color: "#111827",
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px",
          marginBottom: "50px",
        }}
      >
        <FiCheckSquare style={{ color: "#22c55e", fontSize: "1.8rem" }} />
        What Our Customers Say
      </h2>

      {/* Testimonials */}
      <div
        style={{
          maxWidth: "960px",
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          gap: "32px",
        }}
      >
        {testimonials.map((item, index) => (
          <div
            key={index}
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "12px",
              padding: "20px 30px",
              boxShadow: "0 12px 30px rgba(0, 0, 0, 0.05)",
              textAlign: "center",
            }}
          >
            {/* Stars */}
            <div style={{ color: "#fbbf24", fontSize: "1rem", marginBottom: "12px" }}>
              {[...Array(5)].map((_, i) => (
                <FaStar key={i} />
              ))}
            </div>

            {/* Quote */}
            <p
              style={{
                fontSize: "1.25rem",
                fontStyle: "italic",
                color: "#111827",
                marginBottom: "24px",
              }}
            >
              “<span style={{ fontStyle: "italic" }}>{item.quote}</span>”
            </p>

            {/* Name */}
            <p
              style={{
                fontWeight: "600",
                color: "#374151",
                marginBottom: "4px",
              }}
            >
              — {item.name}
            </p>

            {/* Title */}
            <p
              style={{
                color: "#6b7280",
                fontSize: "0.95rem",
              }}
            >
              {item.title}
            </p>
          </div>
        ))}
      </div>
    </section>
    </>
  );
};

export default SettlementSection;
